import { ImpactEnum, TransactionType } from './../../core/enums/enums';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TransactionTag, TransactionTarget } from 'src/app/core/enums/enums';
import { Currency } from 'src/app/core/models/Common';
import { Wallet } from 'src/app/core/models/Group';
import { ITransaction } from 'src/app/core/models/Transaction';
import { UseCaseHcpService } from 'src/app/core/rest-services/rest-services';
import { LanguageService } from 'src/app/core/services/language.service';
import { RoleService } from 'src/app/core/services/role.service';
import { SessionService } from 'src/app/core/services/session.service';
import { toLocaleDateTime } from 'src/app/core/utils/datetime';
import { toHealthCredit, toMoney } from 'src/app/core/utils/misc';
import { OptionObject } from 'src/app/core/utils/type';

@Component({
  selector: 'app-hcp-finances',
  templateUrl: './hcp-finances.component.html',
  styleUrls: ['./hcp-finances.component.scss'],
})
export class HcpFinancesComponent implements OnInit {
  translationKeys: string[] = ['kimbo-home.this-month', 'kimbo-home.this-year'];
  infoIsOpen_1: boolean = false;
  infoIsOpen_2: boolean = false;
  infoIsOpen_3: boolean = false;
  isTransitioning = false;
  wallet!: Wallet;
  currency!: Currency;
  language: string = '';
  transactions: ITransaction[] = [];
  avatar: any;
  hcpId!: number;
  optionPeriodDropdown: OptionObject[] = [
    {
      label: '_THIS_MONTH',
      value: 'This Month',
    },
    {
      label: '_THIS_YEAR',
      value: 'this Year',
    },
    {
      label: '_ALL',
      value: 'all',
    },
  ];
  transactionTarget = TransactionTarget;
  transactionTag = TransactionTag;
  transactionType = TransactionType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { caller: string },
    public dialogRef: MatDialogRef<HcpFinancesComponent>,
    private languageService: LanguageService,
    private roleService: RoleService,
    private translateService: TranslateService,
    private sessionService: SessionService,
    private useCaseHcpService: UseCaseHcpService,
  ) {}

  ngOnInit(): void {
    this.hcpId = this.roleService.getCurrentHcpId()!;
    this.currency = this.sessionService.getCurrencie();
    this.avatar = this.sessionService.getUser().image_profil;
    this.language = this.translateService.currentLang;
    this.fetchHcpWallet();
    this.optionPeriodDropdown = [
      {
        label: this.language === 'en' ? 'This Month' : 'Ce mois',
        value: '_THIS_MONTH',
      },
      {
        label: this.language === 'en' ? 'This Year' : 'Cette année',
        value: '_THIS_YEAR',
      },
      {
        label: this.language === 'en' ? 'Show all' : 'Tout afficher',
        value: '_ALL',
      },
    ];
  }

  fetchHcpWallet(): void {
    this.isTransitioning = true;
    this.useCaseHcpService.wallet(this.hcpId).subscribe({
      next: (res: Wallet) => {
        this.wallet = res;
      },
      error: (error) => {
        error = this.translateService.instant('errors.generic');
      },
      complete: () => {
        this.isTransitioning = false;
      },
    });
  }

  fetchTransaction(period: string = ImpactEnum.MONTH): void {
    this.isTransitioning = true;
    this.useCaseHcpService.list_transactions(this.hcpId, period).subscribe({
      next: (res: ITransaction[]) => {
        this.transactions = res;
      },
      error: (error) => {
        error = this.translateService.instant('errors.generic');
      },
      complete: () => {
        this.isTransitioning = false;
      },
    });
  }

  handlePeriodDropdownEvent(period: OptionObject): void {
    if (period.value === '_THIS_MONTH') {
      this.fetchTransaction(ImpactEnum.MONTH);
    } else if (period.value === '_THIS_YEAR') {
      this.fetchTransaction(ImpactEnum.YEAR);
    } else if (period.value === '_ALL') {
      this.fetchTransaction(ImpactEnum.ALL);
    }
  }

  _toHealthCredit(amount: number): number {
    return toHealthCredit(amount, this.currency.rate);
  }

  _toMoney(amount: number): number {
    return toMoney(amount, this.currency.rate);
  }

  _toLocaleDateTime(date: string): string {
    return toLocaleDateTime(new Date(date), this.language);
  }

  toggleInfoIsOpen_1(): void {
    this.infoIsOpen_1 = !this.infoIsOpen_1;
  }

  toggleInfoIsOpen_2(): void {
    this.infoIsOpen_2 = !this.infoIsOpen_2;
  }

  toggleInfoIsOpen_3(): void {
    this.infoIsOpen_3 = !this.infoIsOpen_3;
  }
}
